"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightRailLoader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RightRail = require("./RightRail.style");

var _LoadingScreen = require("../LoadingScreen.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RightRailLoader = ({
  rowCount,
  theme,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_RightRail.StyledRightRail, props, Array.from({
    length: rowCount
  }).map((v, i) => /*#__PURE__*/_react.default.createElement(_LoadingScreen.StyledListItem, {
    key: i,
    width: "36px",
    height: "36px",
    theme: theme
  })));
};

exports.RightRailLoader = RightRailLoader;
RightRailLoader.defaultProps = {
  rowCount: 5
};
RightRailLoader.propTypes = {
  /**
   * number of rows in right rail loader
   */
  rowCount: _propTypes.default.number,

  /**
   * white background :'light' ,
   * dark background:'dark'
   */
  theme: _propTypes.default.oneOf(['light', 'dark'])
};